export default "__VITE_ASSET__7982bb79__"